import React, { FC } from 'react';
import { Link } from 'react-router-dom';


const Arrow: FC = () => {
    return (
        <div className="arrow">

            <style jsx>{`
                .arrow {
                    position: relative;
                    display: inline-block;
                    padding: 0 12px;
                    color: #000;
                    vertical-align: middle;
                    text-decoration: none;
                    font-size: 15px;
                }
                .arrow::before,
                .arrow::after {
                    position: absolute;
                    top: 3px;
                    bottom: 0;
                    left: 0;
                    margin: auto;
                    content: "";
                    vertical-align: middle;
                }
                .arrow::before{
                    left: 30%;
                    width: 6px;
                    height: 6px;
                    border-top: 1px solid #4d4d4d;
                    border-right: 1px solid #4d4d4d;
                    transform: rotate(45deg);
                }
                .arrow:last-child {
                    display: none;
                }
            `}</style>
        </div>
    );
};


type Props = {
    items: {
        title: string;
        href: string;
    }[];
};


export const BreadCrumbs: FC<Props> = ({ items }) => {
    if (items.length === 0) return null;

    return (
        <ol>
            <li className="top-crumbs">
                <a href="/map">
                    <img src="/img/menu/icon-menu-map.png" />
                </a>
            </li>
            <Arrow />
            {items.map(({ title, href }, index) => {
                const t = title.length > 6 ? title.slice(0, 5) + '...' : title;
                return (
                    <>
                        <li className="crumbs">
                            <Link to={href} style={{ textDecoration: "none", height: "20px" }}>
                                <div className="title">
                                    {items.length > 3 && index === 0
                                        ? "•••"
                                        : t}
                                </div>
                            </Link>
                        </li>
                        <Arrow />
                    </>
                );
            })}

            <style jsx>{`
                ol {
                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    margin: 0 auto;
                    max-width: 1200px;
                    padding: 0 12px;
                }
                .top-crumbs {
                    display: flex;
                    margin: 0;
                    padding: 0;
                    width: 25px;
                    height: 25px;
                    justify-content: center;
                    align-items: center;
                }
                .top-crumbs > a {
                    width: 25px;
                }
                .top-crumbs > a > img {
                    width: 25px;
                }
                .crumbs {
                    display: inline-block;
                    margin: 0;
                    padding: 0;
                }
                .title {
                    color: #ff6e00;
                    font-size: 12px;
                }
                li:last-child {
                    display: none;
                }
            `}</style>
        </ol>
    );
};
